import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import cx from 'classnames'
import { intlMessageShape } from 'sb-react-intl'

import { Button } from 'components/_new/controls'
import Text from 'components/_new/typography/Text/Text'
import { Checkmark } from 'components/_new/ui'

import messages from './messages'
import s from './StockNotifyButton.scss'


class StockNotifyButton extends Component {

  static propTypes = {
    productId: PropTypes.number.isRequired,
    onSubscribeToStockNotification: PropTypes.func,
    isSubscribedToStockNotification: PropTypes.bool,
    fullWidth: PropTypes.bool,
    notifyLabel: PropTypes.shape(intlMessageShape),
    subscribedLabel: PropTypes.shape(intlMessageShape),
  }

  static defaultProps = {
    onSubscribeToStockNotification: false,
    notifyLabel: messages.notify,
    subscribedLabel: messages.subscribed,
  }

  state = {
    isFetching: false,
  }

  setIsFetching = (isFetching) => this.setState({ isFetching })

  handleClick = () => {
    const { productId, onSubscribeToStockNotification } = this.props

    this.setIsFetching(true)

    actions.models.fragrance.subscribeToStockNotification(productId)
      .then(
        () => {
          this.setIsFetching(false)

          if (typeof onSubscribeToStockNotification === 'function') {
            onSubscribeToStockNotification()
          }
        },
        () => {
          this.setIsFetching(false)
        }
      )
  }

  render() {
    const { isFetching } = this.state
    const { className, notifyLabel, subscribedLabel, fullWidth, isSubscribedToStockNotification } = this.props

    const buttonClassName = cx(s.button, className, {
      [s.withCheckMark]: isSubscribedToStockNotification,
    })

    return isSubscribedToStockNotification ? (
      <div className={buttonClassName}>
        <Checkmark className={s.checkMark} />
        <Text message={subscribedLabel} size="14-24" />
      </div>
    ) : (
      <Button
        className={buttonClassName}
        fullWidth={fullWidth}
        loading={isFetching}
        title={notifyLabel}
        weight="normal"
        color="brand"
        size="md"
        uppercase
        onClick={this.handleClick}
      />
    )
  }
}


export default StockNotifyButton
